
export const getProjectOpenDate = (context, createdBy, parameters) => {
  const { openDate } = parameters.mutation
  return openDate
}
